import React, { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useSelectedBusiness from '../hooks/business/useSelectedBusiness';

export default function SelectedBusinessRoute(): ReactElement {
  const business = useSelectedBusiness();
  if (!business || !business.dashboard) return <Navigate to="/" />;
  return <Outlet />;
}
